import {
  Stack,
  styled,
} from "@mui/material";
import EliteMode from "../../page-sections/upgrade/DeluxeMode";
import useUserData from "../../hooks/useUserData";
import SuperMode from "../../page-sections/upgrade/SuperMode";
import PremiumMode from "../../page-sections/upgrade/PremiumMode";
import DeluxeMode from "../../page-sections/upgrade/DeluxeMode";
import UltimateMode from "../../page-sections/upgrade/UltimateMode";
import useModes from "../../hooks/useMode";

export default function Upgrade() {
  const { userData } = useUserData()
  const mode = userData?.user?.mode === 5 ? 5 : userData?.user?.mode === 4 && userData?.user?.modeEndAt > Date.now() ? 4 : userData?.user?.mode === 3 && userData?.user?.modeEndAt > Date.now() ? 3 : userData?.user?.mode === 2 && userData?.user?.modeEndAt > Date.now() ? 2 : 1

  return (
    <UpgradeContainer>
      <Stack spacing={2} px={2}>
        <SuperMode isActive={mode === 2} isDisable={mode >= 2} />
        <PremiumMode isActive={mode === 3} isDisable={mode >= 3} />
        <DeluxeMode isActive={mode === 4} isDisable={mode >= 4} />
        <UltimateMode isActive={mode === 5} isDisable={mode >= 5} />
      </Stack>
    </UpgradeContainer >
  );
}

const UpgradeContainer = styled(Stack)(({ theme }) => ({
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: 'relative',
  minHeight: '100%',
}));